import React from 'react'
import {Link} from 'react-router'
import {ReactComponent as NotFound} from '../../assets/Icons/NotFound.svg'
import styles from './styles.module.scss'
import {useWt} from '@npm-questionpro/wick-ui-lib'
import {GLOBAL} from '../../Translation/English/global'

interface INotfoundPageProps {
  error?: string
}

export const NotfoundPage: React.FC<INotfoundPageProps> = ({error}) => {
  const wt = useWt()

  return (
    <div className={styles.notFound} data-testid="not-found-block">
      <NotFound />
      <p className={styles.title}>{error || wt(GLOBAL.somethingWentWrong)}</p>
      <p className={styles.subTitle}>{wt(GLOBAL['404'])}</p>
      <Link
        className={styles.link}
        to="/"
        onClick={() => localStorage.removeItem('pathname')}
      >
        <p>{wt(GLOBAL.goHome)}</p>
      </Link>
    </div>
  )
}
